// Minimal markdown: ## headings, **bold**, paragraphs, "- " lists
export default function Markdown({ text }) {
  if (!text) return <p className="text-sm text-slate-500">—</p>;
  const blocks = text.split(/\n{2,}/);
  return (
    <div className="space-y-4 text-slate-700 leading-relaxed text-sm md:text-base" data-testid="markdown">
      {blocks.map((b, i) => {
        const lines = b.split("\n");
        if (lines[0].startsWith("## ")) return <h3 key={i} className="font-heading text-lg font-black text-slate-900">{lines[0].slice(3)}</h3>;
        if (lines.every((l) => l.startsWith("- "))) return <ul key={i} className="list-disc pl-6 space-y-1">{lines.map((l, j) => <li key={j}>{inline(l.slice(2))}</li>)}</ul>;
        return <p key={i} className="whitespace-pre-line">{inline(b)}</p>;
      })}
    </div>
  );
}

function inline(s) {
  return s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") ? <strong key={i} className="font-bold text-slate-900">{part.slice(2, -2)}</strong> : part
  );
}
